import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class VersionCheck {
// this will be replaced by actual hash post-build.js
private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
constructor(private http: HttpClient) { }
/**
* Checks in every set frequency the version of frontend application
    * @param {any} url
    * @param {number} frequency - in milliseconds, defaults to 30 minutes
    */
    public initVersionCheck(url='', frequency = 1000 * 60) {
      var server_env = ['production', 'preprod'];
      if (server_env.includes(environment.environment)){
        this.checkVersion(url);
      } 
    }

  public initVersionCheckForComponent(url='', frequency = 1000 * 60) {
    var dateObj = new Date(), versionCheckValue={'version_check':'false'};
    dateObj.setDate(dateObj.getDate() - 1);
    versionCheckValue['expiry_date'] = dateObj;
    var server_env = ['production', 'preprod'];
    if (JSON.stringify(localStorage.getItem('version_detail')) != 'null'){
      versionCheckValue  = JSON.parse(localStorage.getItem('version_detail'));
    }
    var currentDate = new Date();
    if (currentDate > new Date(versionCheckValue['expiry_date'])){
      versionCheckValue['version_check'] = 'true'
    }
    if (server_env.includes(environment.environment) && versionCheckValue['version_check'] == 'true' && currentDate > new Date(versionCheckValue['expiry_date'])){
      var date = new Date();
      var tomorrow = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59);
      localStorage.setItem('version_detail',JSON.stringify({'version_check':false, 'expiry_date':tomorrow}));
      this.checkVersion(url);
    }  
  }

  /**
* Will do the call and check if the hash has changed or not
* @param url
*/
private checkVersion(url:any) {
  // timestamp these requests to invalidate caches
  this.http.get(url + '?t=' + new Date().getTime())
  .subscribe(
  (response: any) => {
  const hash = response.hash;
  const hashChanged = this.hasHashChanged(this.currentHash, hash);
  // If new version, do something
  if (hashChanged) {
  window.location.reload();
  // ENTER YOUR CODE TO DO SOMETHING UPON VERSION CHANGE
  }
  // store the new hash so we wouldn't trigger versionChange again
  // only necessary in case you did not force refresh
  this.currentHash = hash;
  },
  (err) => {
  console.error(err, 'Could not get version');
  }
  );
  }
  /**
  * Checks if hash has changed.
  * This file has the JS hash, if it is a different one than in the version.json
  * we are dealing with version change
  * @param currentHash
  * @param newHash
  * @returns {boolean}
  */
  private hasHashChanged(currentHash:any, newHash:any) {
  console.log('currenthash', currentHash)
  console.log('posthash', '{{POST_BUILD_ENTERS_HASH_HERE}}')
  if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
  return false;
  }
  return currentHash !== newHash;
  }
}
